






















import { Vue, Component, Prop } from "vue-property-decorator";

@Component({})
export default class passwordInput extends Vue {
  @Prop(String) text_placeholder!: string;
  @Prop(String) pass_validate!: string;
  @Prop(Number) type_pass!: number;
  passwordType = "password";
  password = "";
  hash = Math.random() * 100000;
  changeInput(event: any) {
    this.$emit("passwordChange", event, this.type_pass);
  }

  showPassword() {
    this.passwordType = this.passwordType === "password" ? "text" : "password";
  }
}
